import { IResponse } from "models";

export enum ActionType {
  UPDATE_USER_STATUS = "action/UPDATE_USER_STATUS",
  UPDATE_USER_STATUS_SUCCESS = "action/UPDATE_USER_STATUS_SUCCESS",
  UPDATE_USER_STATUS_ERROR = "action/UPDATE_USER_STATUS_ERROR",
  UPDATE_USER_STATUS_RESET = "action/UPDATE_USER_STATUS_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IUpdateUserStatusPayload {
  id: number;
  status: number;
}

export interface UpdateUserStatusResponse extends IResponse {}
